import { Icon, notification } from 'antd'
import React from 'react'
import { TaskItemStore } from 'src/stores/systemNotifications/notification-store'
import { WithTranslation, withTranslation } from 'react-i18next'
import { Query } from '../../core/stores/dataStore'
import { connect } from 'redux-scaffolding-ts'
import { NotificationType } from './notification-Item'

export interface TaskListProps extends WithTranslation {
    reload: number
}
export interface TaskListState {
    query: Query,
    busy: boolean,
    keys: string[]
}
@connect(["Tasks", TaskItemStore])
class TaskList extends React.Component<TaskListProps, TaskListState> {

    constructor(props: any) {
        super(props)
        this.state = {
            query: {
                searchQuery: '',
                orderBy: [{ field: 'startTime', direction: 'Descending', useProfile: false }],
                skip: 0,
                take: 25,
            } as Query
            ,
            busy: false,
            keys: []
        }
    }

    private GetTitle(type: string) {
        switch (type) {
            //Insert
            case NotificationType.BulkInsertTimesheetTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Processing the uploaded file...")} </>

            case NotificationType.BulkInsertProjectsTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Processing the uploaded file...")} </>
            case NotificationType.BulkInsertEmployeesTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Processing the uploaded file...")} </>
            case NotificationType.BulkMembersAssigmentTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Processing the uploaded file...")} </>

            case NotificationType.BulkProjectTaskAssignmentTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Processing the uploaded file...")} </>

            case NotificationType.BulkInsertTaskTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Processing the uploaded file...")} </>


            //Export
            case NotificationType.TimeSheetExportQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Timesheet...")} </>

            case NotificationType.TimeSheetExportStandardQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Timesheet...")} </>

            case NotificationType.TimeSheetExportWithParametersQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Employees Report...")} </>

            case NotificationType.ExportCompanyQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Companies...")} </>

            case NotificationType.ExportLogsReportQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Reports...")} </>

            case NotificationType.ExportBulkTemplateQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Timesheet...")} </>

            case NotificationType.ExportBulkEmployeeTemplateQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Employee...")} </>

            case NotificationType.ExportMembersAssigmentTemplate:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Members Assignment...")} </>

            case NotificationType.ExportProjectTaskTemplateQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Excel Tasks...")} </>

            case NotificationType.ExportEmployeesQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating excel of employees...")} </>

            case NotificationType.ExportProjectsTemplateQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Projects Template...")} </>

            case NotificationType.ExportBulkTaskTemplateQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Tasks Template...")} </>

            case NotificationType.ExportProjectsQueryHandler:
                return <><Icon type="file-excel" style={{ marginRight: 10 }} />  {this.props.t("Creating Projects Excel...")} </>

        }
        return <><Icon type="thunderbolt" style={{ marginRight: 10 }} />  {this.props.t(type)} </>
    }

    componentWillMount() {
        this.load()
    }

    private openNotification() {
        var items = this.TaskStore.state.items
        var keys = this.state.keys
        for (let i = 0; i < items.length; i++) {
            var x = items[i]
            if (!keys.any(k => k == x.item.id)) {
                notification.success({
                    message: <>{this.GetTitle(x.item.type)} </>,
                    duration: 0,
                    closeIcon: <></>,
                    className: "custom-notification-process",
                    icon: <><Icon type="loading" style={{ color: "rgb(0,0,164)" }} /> </>,
                    key: x.item.id,
                    placement: "bottomLeft",
                })
                keys.push(x.item.id);
            }
        }
        for (let i = 0; i < keys.length; i++) {
            if (!items.any(x => x.item.id == keys[i])) {
                notification.close(keys[i])
            }
        }
        this.setState({ keys: keys });
    };


    private async load() {
        this.setState({ busy: true })
        await this.TaskStore.getAllAsync(this.state.query)
        this.setState({ busy: false })
        this.openNotification()
    };

    private get TaskStore() {
        return (this.props as any).Tasks as TaskItemStore
    }

    componentWillReceiveProps(nextProps: TaskListProps) {

        if (this.props.reload != nextProps.reload) {
            this.load()
        }
    }

    render(): React.ReactNode {

        const { t } = this.props

        return (<React.Fragment>

        </React.Fragment>)
    }
};

export default withTranslation()(TaskList)
